// ============================================================
// ANVITH DAZZLE — CLIENT CONFIGURATION
// ============================================================

const config = {
  // ── Brand ────────────────────────────────────────────────
  brandName: "Anvith Dazzle",
  tagline: "Premium Stainless Steel Jewellery",
  logoText: "AD",

  // ── Contact Details ──────────────────────────────────────
  whatsappNumber: "919600091866",
  phone: "+91 9600091866",
  email: "anvithdazzle@gmail.com",
  address:
    "Plot No C39, Dr Chelladurai Nagar, Krishnapuram, Tirunelveli - 627011",
  storeHours:
    "Customer Support Available Monday - Saturday | 10 AM - 8 PM",

  // ── Social Media ─────────────────────────────────────────
  instagramHandle: "anvithdazzle",

  // ── Admin ────────────────────────────────────────────────
  adminEmail: "admin@anvithdazzle.com",

  // ── SEO ──────────────────────────────────────────────────
  seoTitle:
    "Anvith Dazzle | Premium Stainless Steel Jewellery",
  seoDescription:
    "Explore stylish, durable and affordable stainless steel jewellery including rings, chains, bracelets, bangles, watches and fashion accessories.",
  seoKeywords:
    "stainless steel jewellery, rings, chains, bracelets, bangles, watches, fashion accessories, Anvith Dazzle, Tirunelveli",

  // ── WhatsApp Messages ────────────────────────────────────
  whatsappGreeting:
    "Hello Anvith Dazzle! I would like to know more about your jewellery collection.",

  whatsappOrderQuery:
    "Hello Anvith Dazzle! I have a question regarding my order.",
};

// WhatsApp URL
config.whatsappUrl = (message) =>
  `https://wa.me/${config.whatsappNumber}?text=${encodeURIComponent(
    message || config.whatsappGreeting
  )}`;

// Instagram URL
config.instagramUrl = `https://instagram.com/${config.instagramHandle}`;

export default config;